var map = {
	"./template.bet575": 1548,
	"./template.bet575.tsx": 1548,
	"./template.bet777": 1549,
	"./template.bet777.tsx": 1549,
	"./template.betblast": 1550,
	"./template.betblast.tsx": 1550,
	"./template.betprofessor": 1551,
	"./template.betprofessor.tsx": 1551,
	"./template.betroyale": 1552,
	"./template.betroyale.tsx": 1552,
	"./template.betstride": 1553,
	"./template.betstride.tsx": 1553,
	"./template.buffalobet": 1554,
	"./template.buffalobet.tsx": 1554,
	"./template.chromabet": 1555,
	"./template.chromabet.tsx": 1555,
	"./template.default": 667,
	"./template.default.tsx": 667,
	"./template.fiestabet": 1556,
	"./template.fiestabet.tsx": 1556,
	"./template.gigabet": 1557,
	"./template.gigabet.tsx": 1557,
	"./template.goldenbet888": 1558,
	"./template.goldenbet888.tsx": 1558,
	"./template.goldenrush": 1559,
	"./template.goldenrush.tsx": 1559,
	"./template.hyperbet": 1560,
	"./template.hyperbet.tsx": 1560,
	"./template.juicybet": 1561,
	"./template.juicybet.tsx": 1561,
	"./template.junglebet": 1562,
	"./template.junglebet.tsx": 1562,
	"./template.magnumbet": 1563,
	"./template.magnumbet.tsx": 1563,
	"./template.puntcity": 1564,
	"./template.puntcity.tsx": 1564,
	"./template.questbet": 1565,
	"./template.questbet.tsx": 1565,
	"./template.slambet": 1566,
	"./template.slambet.tsx": 1566,
	"./template.templebet": 1567,
	"./template.templebet.tsx": 1567,
	"./template.titanbet": 1568,
	"./template.titanbet.tsx": 1568,
	"./template.ts": 980,
	"./template.vikingbet": 1569,
	"./template.vikingbet.tsx": 1569,
	"./template.volcanobet": 1570,
	"./template.volcanobet.tsx": 1570,
	"./template.wellbet": 1571,
	"./template.wellbet.tsx": 1571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2439;